import React, { useState } from "react";
import { useEffect } from 'react';
import { navigate } from 'gatsby';
import { useFormik } from 'formik';
import * as yup from "yup";
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Button, Col, Form, Row } from 'react-bootstrap';

const BannerForm = () => {

  const [curCity, setCity] = useState();
  const [curCountry, setCountry] = useState();
  const [curRegion, setRegion] = useState();
  const [curZip, setZip] = useState();
  const [successMsg, setsuccessMsg] = useState("");
  const [disable, setDisable] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const key = 'contact_form';
  const company_id = "5e009853504760538164215a";
  const pipeline = "5e0099e250476053816421da";
  const source = "5e009cad504760538164225f";
  const apikey = '5d36920f9f0f6f0545a66adc'
  const publickey = '5c57df40e648e77911f92a63d30db90edbe35106'
  const signature = 'c65ca346abb7a13e376c62bb42dbd3620b07c416'
  const address = {
    countryCode: curCountry,
    regionName: curRegion,
    city: curCity,
    zip: curZip,
  }
  const userCountry = address.countryCode?.toLowerCase();
  const formUrl = typeof window !== 'undefined' ? window.location.href : null;
  const additional_info = {
    url: formUrl,
  }

  useEffect(() => {

    axios.get('https://ipinfo.io/json').then((result) => {
      setCountry(result.data['country']);
      setRegion(result.data['region']);
      setZip(result.data['postal']);
      setCity(result.data['city']);
    })
  }, []);

  const validationSchema = yup.object().shape({
    full_name: yup.string().required('Name is required').matches(/^[aA-zZ\s]+$/, "Name is invalid"),
    email: yup.string().required('Email is required').email('Email is invalid'),
    phone_no: yup.string().required("Phone Number is required").min(3, "Mobile Number required"),
    description: yup.string().required('Message is required'),
  });

  const formikLogin = useFormik({
    initialValues: {
      full_name: "",
      email: "",
      phone_no: "",
      budget: "",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {

      setDisable(true);
      setIsLoading(true);

      try {
        // let result = await fetch("https://q0j7z0lfs5.execute-api.us-west-2.amazonaws.com/lambda-create-deal", {
        //   method: "POST",
        //   body: JSON.stringify({ full_name: values.full_name, email: values.email, phone_no: values.phone_no, description: values.description + ' (Budget : ' + values.budget + ')', key, address, additional_info, company_id, source, pipeline }),
        //   headers: { 'Content-Type': 'application/json' },
        // });

        let result_pms_crm_lead = await fetch("https://9cdbp7k459.execute-api.us-west-2.amazonaws.com/default/pms_crm_lead", {
          method: "POST",
          body: JSON.stringify({ full_name: values.full_name, email: values.email, phone_no: values.phone_no, description: values.description + ' (Budget : ' + values.budget + ')', key, address, additional_info, company_id, source, pipeline, apikey, publickey, signature }),
          headers: { 'Content-Type': 'application/json' },
        });

        let result_hubspot_lead = await fetch("https://qtjs8w6uzg.execute-api.us-west-2.amazonaws.com/default/hubspot_lead", {
          method: "POST",
          body: JSON.stringify({ full_name: values.full_name, email: values.email, phone_no: values.phone_no, description: values.description + ' (Budget : ' + values.budget + ')', key, address, additional_info, company_id, source, pipeline, apikey, publickey, signature }),
          headers: { 'Content-Type': 'application/json' },
        });

        result_pms_crm_lead = await result_pms_crm_lead.json();
        result_hubspot_lead = await result_hubspot_lead.json();

        if (result_pms_crm_lead.status === 200 || result_hubspot_lead.status === 200) {
          setsuccessMsg(false);
          setDisable(false);
          setIsLoading(false);
          navigate('/thankyou.html');
          resetForm();

        } else {

          setDisable(false);
          setIsLoading(false);
          setsuccessMsg("Some error occured else");

        }

      } catch (err) {

        setDisable(false);
        setIsLoading(false);
        setsuccessMsg("Some error occured catch");

      }

    }

  });

  const { errors, touched } = formikLogin;


  return (
    <>

      <div className="banner-form-box dark-box-1 p-4 p-lg-5">
        <div className="mb-5 text-center">
          <h2 className="heading h3 text-white">Share us the details</h2>
          <p className="text-white-75 lead">Fill your requirements to get started!</p>
        </div>
        <Form>
          <Row md={2} xs={1}>
            <Form.Group as={Col} className="mb-4">
              <Form.Control
                type="text"
                name="full_name"
                value={formikLogin.values.full_name}
                onChange={formikLogin.handleChange}
                onBlur={formikLogin.handleBlur}
                placeholder="Enter your name *"
              />
              <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                {errors.full_name && touched.full_name ? errors.full_name : null}
              </p>
            </Form.Group>
            <Form.Group as={Col} className="mb-4">
              <Form.Control
                type="email"
                name="email"
                value={formikLogin.values.email}
                onChange={formikLogin.handleChange}
                onBlur={formikLogin.handleBlur}
                placeholder="Enter your email address *"
              />
              <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                {errors.email && touched.email ? errors.email : null}
              </p>
            </Form.Group>
            <Form.Group as={Col} className="mb-4">
              <PhoneInput
                inputProps={{ name: "phone_no" }}
                inputClass="form-control-phone"
                containerClass="country-phone"
                onChange={(e) => formikLogin.setFieldValue("phone_no", e)}
                onBlur={formikLogin.handleBlur}
                value={formikLogin.values.phone_no}
                country={userCountry ? userCountry : 'us'}
                countryCodeEditable={false}
                inputStyle={{ width: "inherit" }}
              />
              <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                {errors.phone_no && touched.phone_no ? errors.phone_no : null}
              </p>
            </Form.Group>
            <Form.Group as={Col} className="mb-4">
              <Form.Select name="budget"
                aria-label="Budget"
                value={formikLogin.values.budget}
                onChange={formikLogin.handleChange}
                onBlur={formikLogin.handleBlur}>
                <option value="">Budget *</option>
                <option value="Below $10K">Below $10K</option>
                <option value="$10K - $25K">$10K - $25K</option>
                <option value="$25K - $50K">$25K - $50K</option>
                <option value="$50K - 100K">$50K - 100K</option>
                <option value="$100K and more">$100K and more</option>
              </Form.Select>
            </Form.Group>
          </Row>
          <Form.Group className="mb-4">
            <Form.Control
              as="textarea"
              name="description"
              value={formikLogin.description}
              onChange={formikLogin.handleChange}
              onBlur={formikLogin.handleBlur}
              placeholder="Message *"
              rows={3}
            />
            <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
              {errors.description && touched.description ? errors.description : null}
            </p>
          </Form.Group>

          <div className="form-action text-end">
            <Button type="button" onClick={() => formikLogin.handleSubmit()} disabled={disable} variant="" size="lg" className="btn-primary-theme mt-2">
              <span>{isLoading ? 'Sending...' : 'Send Now'}</span>
            </Button>
          </div>
          {successMsg ? <div className="alert alert-success mt-4"> {successMsg} </div> : null}
        </Form>
      </div>
    </>
  );
}

export default BannerForm
